import React, { memo, useState, FC, useEffect } from "react";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import {
  Box,
  Button,
  Flex,
  Heading,
  Select,
  TextField,
  Text,
} from "@radix-ui/themes";
import { Cross1Icon, Cross2Icon, PlusIcon } from "@radix-ui/react-icons";

const CreateChallengeMixedTextSelectInput: FC<{
  fields: any;
  initialField: string;
  initialNumber: string | number;
  objectsLength: number;
  index: number;
  critType: string;
  handleUpdateCriteriaList: (
    type: "empty" | "add" | "remove" | "addEmpty",
    value?: number,
    key?: any
  ) => void;
  isSelectedOption: boolean;
  isEdit: boolean;
  selectedFields: any;
}> = ({
  initialField,
  initialNumber,
  fields,
  objectsLength,
  index,
  critType,
  handleUpdateCriteriaList,
  isSelectedOption,
  isEdit,
  selectedFields,
}): JSX.Element => {
  const [inputValue, setInputValue] = useState<any>(initialNumber || 1);
  const [selectValue, setSelectValue] = useState<any>(initialField);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (isEdit) {
      return;
    }
    if (critType === "simple" && inputValue && selectValue && hasClicked) {
      handleUpdateCriteriaList("empty");
      setError("");
      return handleUpdateCriteriaList("add", Number(inputValue), selectValue);
    }

    if (!hasClicked) {
      return;
    }
    if (!inputValue || inputValue === 0) {
      return setError("Please enter a valid amount.");
    }
    if (!selectValue) {
      return setError("Please pick a criteria.");
    }

    if (inputValue && selectValue) {
      setError("");
    }
    return setError("");
  }, [selectValue, inputValue, hasClicked]);

  return (
    <>
      <Flex gap="2">
        {critType === "advanced" ? (
          <>
            <Flex gap="2" direction="column">
              <TextField.Root
                placeholder="Enter a number"
                size="2"
                type="text"
                style={{ maxWidth: "80px" }}
                value={inputValue}
                onChange={(e) => {
                  if (isSelectedOption) {
                    return;
                  }
                  if (critType === "advanced" && Number(e.target.value) < 0) {
                    setInputValue(0);
                    setHasClicked(true);
                    return;
                  }
                  setHasClicked(true);
                  setInputValue(e.target.value);
                }}
                onBlur={(e) => {
                  if (isSelectedOption) {
                    return;
                  }
                  if (
                    (critType === "advanced" && Number(inputValue) <= 0) ||
                    Number(inputValue) < 0
                  ) {
                    setInputValue(0);
                    setHasClicked(true);
                    setError("Please enter a valid number.");
                    return;
                  }
                  setHasClicked(true);
                  setInputValue(e.target.value);
                }}
                disabled={isSelectedOption}
              />
            </Flex>

            <div className="item__multiply">
              <Cross1Icon />
            </div>
          </>
        ) : (
          <Select.Root
            defaultValue={inputValue}
            value={inputValue}
            onValueChange={(e) => {
              setInputValue(e);
              setHasClicked(true);
            }}
          >
            <Select.Trigger placeholder="Max or min" />

            <Select.Content>
              <Select.Group>
                <Select.Item value="1">Max</Select.Item>
                <Select.Item value="-1">Min</Select.Item>
              </Select.Group>
            </Select.Content>
          </Select.Root>
        )}

        <Select.Root
          defaultValue={selectValue}
          value={selectValue}
          onValueChange={(e) => {
            if (isSelectedOption) {
              return;
            }
            setHasClicked(true);
            if (e) {
              setSelectValue(e);
              // setUpdateTrigger((prev) => prev + 1);
            }
          }}
          disabled={isSelectedOption}
        >
          <Select.Trigger placeholder="Choose an option" />

          <Select.Content>
            <Select.Group>
              <Select.Label>Criteria</Select.Label>

              {fields.map((f) => {
                if (f) {
                  return (
                    <Select.Item value={f.value} key={f.value}>
                      {f.text}
                    </Select.Item>
                  );
                }
              })}
            </Select.Group>
          </Select.Content>
        </Select.Root>

        {critType === "advanced" && (
          <>
            <Box>
              {!isSelectedOption && (
                <Button
                  variant="outline"
                  onClick={() => {
                    if (selectValue && inputValue && !error) {
                      handleUpdateCriteriaList(
                        "add",
                        Number(inputValue),
                        selectValue
                      );
                      setSelectValue("");
                      setError("");
                      setInputValue(1);
                      setHasClicked(false);
                    }
                  }}
                >
                  <PlusIcon />
                  Add to list
                </Button>
              )}

              {!isEdit && isSelectedOption && selectValue && (
                <Button
                  color="red"
                  variant="outline"
                  onClick={() =>
                    handleUpdateCriteriaList(
                      "remove",
                      Number(inputValue),
                      selectValue
                    )
                  }
                >
                  <Cross2Icon />
                  Remove
                </Button>
              )}
            </Box>
          </>
        )}
      </Flex>
      {!isSelectedOption && error && (
        <FormErrorMessage text={error} isVisible={!!error} />
      )}
    </>
  );
};

export default memo(CreateChallengeMixedTextSelectInput);
